import '../CsvJsonInfoPages.scss';


function NewVehicleDataChanges() {

    const data = [
        { field: 1, description: 'CAP ID Number (Int)' },
        { field: 2, description: 'Creation Date (Date, yyyy/mm/dd)' },
        { field: 3, description: 'Price Creation Date (Date, yyyy/mm/dd)' },
        { field: 4, description: 'Reintroduction Date (Date, yyyy/mm/dd)' },
        { field: 5, description: 'Discontinuation Date (Date, yyyy/mm/dd)' },
        { field: 6, description: 'CAP Code Change Date (Date, yyyy/mm/dd)' },
        { field: 7, description: 'Old CAP Code (String)' },
        { field: 8, description: 'New CAP Code (String)' },
        { field: 9, description: 'Last Price Change Date (Date, yyyy/mm/dd)' },
        { field: 10, description: 'Last Delivery Cost Change Date (Date, yyyy/mm/dd)' },
        { field: 11, description: 'Last Option Price Change Date (Date, yyyy/mm/dd)' },
        { field: 12, description: 'Last Option Change Excluding Trims and Colours Date (Date, yyyy/mm/dd)' },
        { field: 13, description: 'Last Standard Equipment Change Date (Date, yyyy/mm/dd)' },
        { field: 14, description: 'Last Standard Equipment Excluding Trims and Colours Date (Date, yyyy/mm/dd)' },
        { field: 15, description: 'Last Technical Data Change Date (Date, yyyy/mm/dd)' },
        { field: 16, description: 'Last Colour Trims and Hoods Change Date (Date, yyyy/mm/dd)' },
        { field: 17, description: 'Last Option Relationships Change Date (Date, yyyy/mm/dd)' },
        { field: 18, description: 'Last Generic Status Change Date (Date, yyyy/mm/dd)' },
        { field: 19, description: 'Last Paint and Trims Change Date (Date, yyyy/mm/dd)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - New Vehicle Data Changes</h1>
            <p>This file contains information regarding date changes to specific CAP iDs.<br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDChanges.txt<br />
                LIGHTS_yyyy-mm-dd_ NVDChanges.txt<br />
                HEAVIES_yyyy-mm-dd_ NVDChanges.txt<br />
                BIKES_yyyy-mm-dd_ NVDChanges.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default NewVehicleDataChanges;
